export function baseURL() {
    return window.location.hostname;
}

export function callAPI( methodName = '' ) {
    return `https://api.alaskacykler.dk/v1/7F138A09169B250E9DCB378140907378/${methodName}`;
}


// WEBPACK FOOTER //
// ./src/Core/Base.js